import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { AcademyService } from "../report-services/academy.service";
import { GradeLevelService } from "../report-services/grade-level.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { GroupService } from "../report-services/group.service";
import { UserService } from "../../../shared";
import { PersonTypeService } from "../report-services/person-type.service";

@Component({
	selector: "app-active-barcodes-scannable",
	templateUrl: "./active-barcodes-scannable.component.html",
})
export class ActiveBarcodesScannableComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private userService: UserService,
		private dialogService: DialogService,
		private personTypeService: PersonTypeService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		GradeLevelID: 0,
		HomeroomID: 0,
		AcademyID: 0,
		GroupID: 0,
		PersonTypeID: -1,
		BarcodeTypeID: 2,
		ActiveOptionID: 1,
		StudentSortByID: "FirstName",
		StaffSortByID: "FirstName",
		SortDirectionID: "ASC",
		ImageLogo: "",
		PersonMode: "Student",
	};

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	//Insert Custom Lists Here
	GradeLevelList: any = [];
	AcademyList: any = [];
	HomeroomList: any = [];
	GroupList: any = [];
	PersonTypeList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	StudentSortByList = [
		//Insert Custom List Items Here
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "ID",
			Desc: "Student ID",
		},
		{
			ID: "GradeLevel",
			Desc: "Grade",
		},
		{
			ID: "Homeroom",
			Desc: "Homeroom",
		},
		{
			ID: "Academy",
			Desc: "Academy",
		},
		{
			ID: "IssueDate",
			Desc: "Issue Date",
		},
	];

	StaffSortByList = [
		//Insert Custom List Items Here
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "ID",
			Desc: "Staff ID",
		},
		{
			ID: "PersonType",
			Desc: "Staff Type",
		},
		// {
		// 	ID: "Title",
		// 	Desc: "Staff Title",
		// },
		// {
		// 	ID: "IssueDate",
		// 	Desc: "Issue Date",
		// },
	];

	SortDirectionList = [
		//Insert Custom List Items Here
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	BarcodeTypeList = [
		{
			ID: 1,
			Desc: "Student/Staff ID",
		},
		{
			ID: 2,
			Desc: "Any ID Card Barcode",
		},
		{
			ID: 3,
			Desc: "CAASS Barcode",
		},
		{
			ID: 4,
			Desc: "RFID UID",
		},
	];

	ActiveOptionList = [
		{
			ID: -1,
			Desc: "Any",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	PersonModeList = ["Student", "Staff"];

	// pdf = 1
	// doc = 2
	// xls = 3
	// csv = 4
	// rtf = 5
	// xml = 6
	// htm = 7
	// rpt = 8
	// grp = 9

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		// {
		// 	ID: 4,
		// 	Desc: ".CSV (Excel file)",
		// },
		{
			ID: 5,
			Desc: ".rtf (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	subscription: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadGradeLevelList()
		// this.loadAcademyList()
		// this.loadHomeroomList()

		this.loadPersonTypeList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevelList();
		this.loadAcademyList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private loadPersonTypeList() {
		this.report.PersonTypeID = 0;
		var result = this.personTypeService.loadPERSONTYPEList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.PersonTypeList = response;

				// this.PersonTypeList.unshift({
				// 	PersonTypeID: 0,
				// 	PersonTypeDesc: "All",
				// });

				this.report.PersonTypeID = this.PersonTypeList[0].PersonTypeID;
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadAcademyList() {
		this.report.AcademyID = 0;
		var result = this.academyService.loadAcademyList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				if (this.AcademyList.length > 1) {
					// this.AcademyList.unshift({
					//     AcademyID: 0,
					//     AcademyDesc: "All Academys"
					// })
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				} else {
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					//  this.HomeroomList.unshift({
					//      HomeroomID: 0,
					//      HomeRoom: "All Homerooms"
					// })
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length > 1) {
					// this.GroupList.unshift({
					//     GroupID: 0,
					//     GroupName: "All Groups"
					// })
					this.report.GroupID = this.GroupList[0].GroupID;
				} else {
					this.report.GroupID = this.GroupList[0].GroupID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.GetReportID(), strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		if (this.report.PersonMode == "Student") {
			//Parameter 1: GradeLevelID
			strParam += this.report.GradeLevelID + "|GradeLevelID";

			//Parameter 2: HomeRoomID
			strParam += "," + this.report.HomeroomID + "|HomeroomID";

			//Parameter 3: AcademyID
			strParam += "," + this.report.AcademyID + "|AcademyID";

			//Parameter 4: GroupID
			strParam += "," + this.report.GroupID + "|GroupID";

			//Parameter 5: BarcodeTypeID
			strParam += "," + this.report.BarcodeTypeID + "|BarcodeTypeID";

			//Parameter 6: Active
			strParam += "," + this.report.ActiveOptionID + "|Active";

			//Parameter 7: SortBy
			strParam += "," + this.report.StudentSortByID + "|SortBy";

			//Parameter 8: SortDirection
			strParam += "," + this.report.SortDirectionID + "|SortDirection";

			//Parameter 9: UserID
			strParam += "," + this.user.userID + "|UserID";

			//Parameter 10: SchoolID
			strParam += "," + this.report.SchoolID + "|SchoolID";

			//Parameter 11: ImageLogo
			strParam += "," + this.report.ImageLogo + "|ImageLogo";
		} else if (this.report.PersonMode == "Staff") {
			//Parameter 1: PersonTypeID
			strParam += this.report.PersonTypeID + "|PersonTypeID";

			//Parameter 2: BarcodeTypeID
			strParam += "," + this.report.BarcodeTypeID + "|BarcodeTypeID";

			//Parameter 3: Active
			strParam += "," + this.report.ActiveOptionID + "|Active";

			//Parameter 4: SortBy
			strParam += "," + this.report.StaffSortByID + "|SortBy";

			//Parameter 5: SortDirection
			strParam += "," + this.report.SortDirectionID + "|SortDirection";

			//Parameter 6: UserID
			strParam += "," + this.user.userID + "|UserID";

			//Parameter 7: SchoolID
			strParam += "," + this.report.SchoolID + "|SchoolID";

			//Parameter 8: ImageLogo
			strParam += "," + this.report.ImageLogo + "|ImageLogo";
		}

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.GetReportID(),
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}

	GetReportID() {
		if (this.report.PersonMode == "Student") {
			return 442;
		} else if (this.report.PersonMode == "Staff") {
			return 462;
		}
	}
}
